import React from "react";
import { Container, Row, Col } from "reactstrap";
// import logoIn from "assets/img/brand/massphoning-in.svg";
// import logoOut from "assets/img/brand/massphoning-out.svg";
// import fetaveLogoOut from "assets/img/brand/FETAVE-out.svg";
// import fetaveLogoIn from "assets/img/brand/FETAVE-in.svg";
import easyCallLogoOut from "assets/img/brand/EasyCall-out-logo.svg";
import easyCallLogoIn from "assets/img/brand/EasyCall-in-logo.svg";
import { Intl, AlternativeAppBtn, Typeform } from "components";

export default React.memo(({ logUser, alternateAppData }) => (
  <Container>
    <Row className="justify-content-center">
      <Col lg={8}>
        <h2 className="text-center font-weight-normal m-0 p-0">
          <Intl id="alternateTitle" />
        </h2>
        <p className="text-center text-muted">
          (
          <Intl id="alternateText" />)
        </p>
        <Row className="mb-4">
          <Col xs={6} className="appselector_col_bordered">
            <AlternativeAppBtn
              className="appselector_link"
              target="_blank"
              token={
                alternateAppData && alternateAppData.access_token
                  ? alternateAppData.access_token
                  : ""
              }
              refreshtoken={
                alternateAppData && alternateAppData.refresh_token
                  ? alternateAppData.refresh_token
                  : ""
              }
              // image={logoOut}
              image={easyCallLogoOut}
              appSelectorAlternativeUrl={
                process.env.REACT_APP_ALTERNATIVE_APP_URL+"" || ""
              }
            />
          </Col>
          <Col xs={6}>
            <AlternativeAppBtn
              className="appselector_link"
              target="_blank"
              token={
                alternateAppData && alternateAppData.access_token
                  ? alternateAppData.access_token
                  : ""
              }
              refreshtoken={
                alternateAppData && alternateAppData.refresh_token
                  ? alternateAppData.refresh_token
                  : ""
              }
              // image={logoIn}
              image={easyCallLogoIn}
              appSelectorAlternativeUrl={"/"}
            />
          </Col>
        </Row>
        {/* <Typeform
          src={{
            es: "https://massphoning.es/typeform_es.html",
            en: "https://massphoning.com/typeform_en.html",
          }}
        /> */}
        <Typeform
          src={{
            es: "https://mediominuto.com/typeform-fetave_tel.html",
            en: "https://mediominuto.com/typeform-fetave_tel.html",
          }}
        />
      </Col>
    </Row>
  </Container>
));
